import { StopIcon } from "@heroicons/react/16/solid";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

export interface IDataUnit {
  label: string;
  colorClass: string; // e.g. "fill-primary", used for the slice and the tooltip icon
}

interface IPieChartGraph {
  dataSet: { key: string; value: number }[];
  dataMap: Record<string, IDataUnit>;
}

function CustomTooltip({ active, payload, dataMap }: any) {
  if (!active || !payload?.length) return null;

  const { key, value } = payload[0].payload;
  const unit = dataMap[key];
  if (!unit) return null;

  return (
    <div className="flex items-center gap-2 bg-white p-2 rounded-md border border-extraLightGray z-10 text-sm font-semibold">
      <StopIcon className={`size-4 ${unit.colorClass}`} />
      <p className="capitalize">{unit.label}:</p>
      <p>{value}</p>
    </div>
  );
}

function PieChartGraph({ dataSet, dataMap }: IPieChartGraph) {
  return (
    <div className="relative h-full w-full min-h-0">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={dataSet}
            dataKey="value"
            nameKey="key"
            innerRadius="70%"
            outerRadius="100%"
            startAngle={90}
            endAngle={-270}
            stroke="none"
            isAnimationActive={false}
          >
            {dataSet.map((d) => (
              <Cell key={d.key} className={dataMap[d.key]?.colorClass} />
            ))}
          </Pie>
          <Tooltip
            content={<CustomTooltip dataMap={dataMap} />}
            wrapperStyle={{ outline: "none", zIndex: 20 }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default PieChartGraph;
